import router, { asyncRoutes, constantRoutes } from '@/router'

/**
 * Through meta.role determines whether the current user rights match
 * @param roles
 * @param route
 */
const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles)
    return roles.some((role) => route.meta.roles.includes(role))

  return true
}

/**
 * Recursively filter asynchronous routing tables to return routing tables
 * that meet user role permissions
 * @param roles
 * @param routes asyncRoutes
 */
export const filterAsyncRoutes = (roles, routes) => {
  const res = []
  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children)
        tmp.children = filterAsyncRoutes(roles, tmp.children)

      res.push(tmp)
    }
  })
  return res
}

const permission = {
  state: {
    routes: [],
    addRoutes: []
  },

  getters: {
    permissionRoutes: (state) => state.routes,
    addRoutes: (state) => state.addRoutes
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    }
  },
  actions: {
    GenerateRoutes: async ({ commit, rootState }, user) => {
      try {
        const { roles } = user
        // Debug logging only in development
        if (process.env.NODE_ENV === 'development') {
          console.log('[DEBUG] GenerateRoutes called with user:', user)
          console.log('[DEBUG] User roles:', roles)
        }
        // Lo convierto a una array, norman 2020
        const rolesArray = (roles && roles.length > 0 ? roles.split(',') : [])
        if (process.env.NODE_ENV === 'development')
          console.log('[DEBUG] Roles array:', rolesArray)

        // ---------------------------------
        let accessedRoutes
        if (rolesArray.includes('admin')) {
          if (process.env.NODE_ENV === 'development')
            console.log('[DEBUG] User is admin, granting all routes')

          accessedRoutes = asyncRoutes
        } else {
          if (process.env.NODE_ENV === 'development')
            console.log('[DEBUG] User is not admin, filtering routes')

          accessedRoutes = filterAsyncRoutes(rolesArray, asyncRoutes)
          if (process.env.NODE_ENV === 'development')
            console.log('[DEBUG] Filtered routes:', accessedRoutes)

          // elimino para que no queden padres sin hijos
          accessedRoutes = accessedRoutes.filter(route => (route.children && route.children.length > 0))
          if (process.env.NODE_ENV === 'development')
            console.log('[DEBUG] Final routes after removing empty parents:', accessedRoutes)
        }

        commit('SET_ROUTES', accessedRoutes)
        // Apply selected allowed routes
        /*
       router.addRoutes(accessedRoutes)
        console.log('[vuex.permission] accessedRoutes ', constantRoutes)
        console.groupEnd()
        */
      } catch (err) {
        console.warn('[vuex.permission] GenerateRoutes', err)
      }
    }
  }
}

export default permission
